import { render, staticRenderFns } from "./LeaveSumStat.vue?vue&type=template&id=2f8c17fe&scoped=true"
import script from "./LeaveSumStat.vue?vue&type=script&lang=js"
export * from "./LeaveSumStat.vue?vue&type=script&lang=js"
import style0 from "./LeaveSumStat.vue?vue&type=style&index=0&id=2f8c17fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8c17fe",
  null
  
)

export default component.exports